"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const class_transformer_1 = require("class-transformer");
function TransformJsonString() {
  const toPlain = (0, class_transformer_1.Transform)(params => {
    return params && params.value ? JSON.stringify(params.value) : null;
  }, {
    toPlainOnly: true
  });
  const toClass = (0, class_transformer_1.Transform)(params => {
    return params && typeof params.value === "string" ? JSON.parse(params.value) : null;
  }, {
    toClassOnly: true
  });
  return function (target, key) {
    toPlain(target, key);
    toClass(target, key);
  };
}
exports.default = TransformJsonString;
